<template>
  <!-- <PageLayout> -->
    <!-- <template #headerTitle> Pronostics </template> -->
    <AllMatches showAds></AllMatches>
  <!-- </PageLayout> -->
</template>
